import { CacheProvider } from '@emotion/react';
import { createTheme, TextField, ThemeProvider } from '@mui/material'
import React, { useRef, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { useSelector } from 'react-redux';
import { tokenInfo } from '../features/tab/tokenInfoSlice';

export default function Doctor() {
    const [secretDoctor, setSecretDoctor] = useState(null);
    const [medDoctor, setMedDoctor] = useState(null);
    const submitRef = useRef(null)
    const [searchParams] = useSearchParams();
    const tokenInformation = useSelector(tokenInfo);

    const secretDoctorChange = (event) => {
        setSecretDoctor(event.target.value)
    }
    const medDoctorChange = (event) => {
        setMedDoctor(event.target.value)
    }
    const onDoctorClickEnter = (event) => {
        if (event.key === 'Enter' && secretDoctor !== '') {
            event.preventDefault();
            event.stopPropagation();
            submitRef.current.click()
        }
    }
    const theme = createTheme({
        direction: 'rtl',
        typography: {
            "fontFamily": "IRANYekan"
        }
    });

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    return (
        <>
            <div className="h-full flex flex-col items-center justify-center" style={{ backgroundColor: "rgba(170, 220, 241,0.3)" }}>
                <p className='pb-6 sm:pb-16 sm:text-2xl text-xl'>پنل پزشکان</p>
                <section>
                    <img src="/images/doctor-il.svg" alt='doctor' className="w-[40%] mx-auto" />
                    <div className='flex flex-col items-center mt-8'>
                        <CacheProvider value={cacheRtl}>
                            <ThemeProvider theme={theme}>
                                <div dir="rtl" className='flex flex-col items-center flex-wrap'>
                                    <TextField type='tel' variant="outlined" value={medDoctor} onChange={medDoctorChange} label="شماره نظام پزشکی" sx={{ width: "300px" }} />
                                    <TextField onKeyDown={onDoctorClickEnter} variant="outlined" type='password' value={secretDoctor} onChange={secretDoctorChange} label="کلمه عبور" className='my-2' sx={{ width: "300px" }} />
                                </div>
                            </ThemeProvider>
                        </CacheProvider>
                        <Link ref={submitRef} to={medDoctor && secretDoctor ? `/doctor-patients?q=${searchParams.get("q")}&m=${medDoctor}&s=${secretDoctor}` : ""}>
                            <button type="button" className='focus:outline-none text-white bg-[#fa3668] font-medium rounded-lg px-8 sm:px-16 py-2.5 mr-4 mt-4'>ادامه</button>
                        </Link>
                        <p className='text-sm sm:text-base mt-4 text-gray-500'>• درصورت داشتن سوال مي توانيد با شماره تلفن {tokenInformation?.tel} تماس بگيريد.</p>
                    </div>
                </section>
                <p className='pt-8 sm:pt-16'>ساخته شده با ❤️ در <a href='https://salus.ir' className="text-[#068dd6] font-bold" rel="noreferrer" target="_blank">سالوس</a></p>
            </div>
        </>
    )
}
